/**
 * Check if an Object is Empty
 * @param {object} obj object name
 */
export const isEmptyObject = (obj) => {
  if (typeof obj === 'object' && Object.keys(obj).length === 0) {
    return true;
  }
  return false;
};

/**
 * Print out Object
 * @param {object} obj object name
 */
export const printObject = (obj) => {
  return JSON.stringify(obj, null, 4);
};
